const API_BASE = import.meta.env.VITE_API_ORIGIN
  ? `${import.meta.env.VITE_API_ORIGIN}/api`
  : 'https://unstablepvp-api.zaiyayok.workers.dev/api'

let authToken: string | null = localStorage.getItem('auth_token')

export function setAuthToken(token: string | null) {
  authToken = token
  if (token) {
    localStorage.setItem('auth_token', token)
  } else {
    localStorage.removeItem('auth_token')
  }
}

export function getAuthToken(): string | null {
  return authToken
}

export function getDiscordAuthUrl(): string {
  const baseUrl = API_BASE.replace('/api', '')
  // Point frontend_url to the dashboard so OAuth callback redirects there with the token
  const dashboardUrl = import.meta.env.VITE_DASHBOARD_URL || 'https://unstablepvp-dashboard.pages.dev'
  const frontendUrl = encodeURIComponent(dashboardUrl)
  return `${baseUrl}/api/auth/discord?frontend_url=${frontendUrl}`
}

export async function checkAuth(): Promise<AuthUser | null> {
  if (!authToken) return null
  try {
    const res = await fetch(`${API_BASE}/auth/me`, {
      headers: { Authorization: `Bearer ${authToken}` },
    })
    if (!res.ok) {
      setAuthToken(null)
      return null
    }
    const data = await res.json()
    return data.user || null
  } catch {
    setAuthToken(null)
    return null
  }
}

export interface AuthUser {
  id: string
  username: string
  avatar: string | null
}